// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1638":"0ce0e137","2563":"b266af7c","9624":"0ce0e137"}[chunkId] + ".chunk.css";
};